export enum ToasterType {
  SUCCESS, INFO, WARN, ERROR
}

export interface IToasterData {
  type:ToasterType;
  message:string;
  isAutoCloseable?:Boolean;
}
